import type React from 'react';

import { Button, Text } from '@change/ds-core-ui';
import { InfoV2Icon } from '@change/ds-icons';

import { Translate } from '@change-corgi/core/react/i18n';

import { footer, footerContainer, helpLink, helpLinkText } from './Footer.styles';

type EndorsementFormFooterProps = {
	onClick: () => void;
	onHelpClick?: () => void;
	isValid?: boolean;
};

export const EndorsementFormFooter: React.FC<EndorsementFormFooterProps> = ({
	onClick,
	onHelpClick,
	isValid = true,
}) => {
	return (
		<footer className={footer()} data-testid="endorsement-form-footer">
			<div className={footerContainer()}>
				<button type="button" className={helpLink()} onClick={onHelpClick} data-testid="endorsement-help-link">
					<InfoV2Icon className="text-typography-strong" size="medium" />
					<Text variant="body" fontWeight="bold" className={helpLinkText()}>
						<Translate value="corgi.petition.starter_dashboard_v2.endorsements.add.help_link" />
					</Text>
				</button>

				<Button
					variant="primary"
					size="large"
					onClick={onClick}
					disabled={!isValid}
					data-testid="endorsement-next-button"
					data-qa="endorsement-next-button"
				>
					<Translate value="corgi.petition.starter_dashboard_v2.endorsements.add.next_button" />
				</Button>
			</div>
		</footer>
	);
};
